var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    opacity: 1,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-585.000000, -707.000000)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(595.300012, 716.800000) scale(-1, 1) translate(-595.300012, -716.800000) translate(585.000000, 707.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99995,9.8 C6.99995,10.2418 7.35813,10.6 7.79995,10.6 L14.60005,10.6 L14.60005,13.8 C14.60005,15.6958 14.07695,17.2272 12.76885,18.2441 C11.50975,19.2228 9.67365,19.6 7.3461,19.6 C5.02385,19.6 3.05748,19.2266 1.7478,17.6175 C0.48837,16.0701 0,13.5625 0,9.8 C0,6.03747 0.48837,3.52987 1.7478,1.9825 C3.05748,0.37338 5.02386,0 7.3461,0 C9.67365,0 11.50975,0.37718 12.76885,1.35589 C14.07695,2.37277 14.60005,3.90423 14.60005,5.8 L14.60005,9 L7.79995,9 C7.35813,9 6.99995,9.3582 6.99995,9.8 Z M17.86865,10.6 L14.60005,10.6 L14.60005,9.0000025 L17.86865,9.0000025 L16.23435,7.36569 C15.92185,7.05327 15.92185,6.54673 16.23435,6.23431 C16.54675,5.9219 17.05325,5.9219 17.36565,6.23431 L20.36565,9.2343 C20.67815,9.5467 20.67815,10.0533 20.36565,10.3657 L17.36565,13.3657 C17.05325,13.6781 16.54675,13.6781 16.23435,13.3657 C15.92185,13.0533 15.92185,12.5467 16.23435,12.2343 L17.86865,10.6 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c685f7576b6c189c12538c559956e0c6.svg";
export { ForwardRef as ReactComponent };